"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/RWFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_198)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_198`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V24.0002H-6V-0.00012207Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 11.9996H30V17.7385H-6V11.9996Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 17.7385H30V23.9994H-6V17.7385Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.5652 7.02257L15.0308 7.71192L14.2504 9.13125L15.8418 8.82679L16.0434 10.4345L17.1519 9.25211L18.2604 10.4345L18.462 8.82679L20.0534 9.13125L19.273 7.71192L20.7385 7.02257L19.2729 6.33316L20.0534 4.9139L18.462 5.21828L18.2604 3.61066L17.1519 4.79303L16.0433 3.61066L15.8418 5.21828L14.2503 4.9139L15.0308 6.3333L13.5652 7.02257Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_198`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as RWFlag };
